import { LINE_NAME_MAP } from '@/constants';

type ColorConfig = {
  bg: string;
  border: string;
  color: string;
};

const lineColors: Record<string, ColorConfig> = {
  [LINE_NAME_MAP.ctrlKids]: {
    bg: 'bg-warning-content',
    border: 'border-warning',
    color: 'warning',
  },
  [LINE_NAME_MAP.ctrlTeens]: {
    bg: 'bg-primary-content',
    border: 'border-primary',
    color: 'primary',
  },
  [LINE_NAME_MAP.ctrlYoung]: {
    bg: 'bg-secondary-content',
    border: 'border-secondary',
    color: 'secondary',
  },
  [LINE_NAME_MAP.ctrlPro]: {
    bg: 'bg-neutral-content',
    border: 'border-neutral',
    color: 'neutral',
  },
  [LINE_NAME_MAP.ctrlQuick]: {
    bg: 'bg-accent-content',
    border: 'border-accent',
    color: 'accent',
  },
};

const defaultColorConfig: ColorConfig = {
  bg: 'bg-base-200',
  border: 'border-neutral-content',
  color: 'base',
};

export const getLineColor = (
  lineName?: string,
  defaultColor: ColorConfig = defaultColorConfig,
): ColorConfig => lineColors[lineName ?? ''] ?? defaultColor;

export const getLineColorClass = (lineName?: string): string => {
  const { bg, border } = getLineColor(lineName);
  return `${bg} border ${border}`;
};
